<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="4" y="3" width="4" height="2" fill="var(--bg-color)" />
    <rect x="4" y="7" width="5" height="2" fill="var(--bg-color)" />
    <rect x="4" y="11" width="4" height="2" fill="var(--bg-color)" />
    <rect x="1" y="3" width="2" height="2" fill="var(--bg-color)" />
    <rect x="12" y="3" width="3" height="2" fill="var(--bg-color)" />
    <rect x="1" y="7" width="2" height="2" fill="var(--bg-color)" />
    <rect x="12" y="7" width="3" height="2" fill="var(--bg-color)" />
    <rect x="1" y="11" width="2" height="2" fill="var(--bg-color)" />
    <rect x="12" y="11" width="3" height="2" fill="var(--bg-color)" />
</svg>
